import {FC} from 'react';
import {Container, Header, Segment, Button, Icon, Grid, Divider} from 'semantic-ui-react';
import {useHistory} from "react-router-dom";
import {useCompanyId} from "../../../core";

const Dashboard = () => {
  const companyId = useCompanyId()



  return (<>
          <Container>
              <Segment>
              <Header as='h2' color="purple">Active Subscriptions</Header>
                      <Subscription
                          title="Portfolio Impact Reporting"
                          description="Report on your ESG Impact across portfolios."
                          url={`/ps/${companyId}/am/dashboard/impact-summary`}
                          accessKind={'Full'}
                      />
                      <Divider />
                      <Subscription
                          title="Portfolio Rollups"
                          description="Aggregate financial and operational performance across portfolios."
                          url={`/ps/${companyId}/am/dashboard/cashflow-rollup`}
                          accessKind={'Full'}
                      />
                      <Divider />
                      <Subscription
                          title="Investor and Management Reporting"
                          description="Provide granular view/edit access to specific portfolios for dynamic reporting that saves time."
                          url={`/ps/${companyId}/am/dashboard/investor-andmanagementreporting`}
                          accessKind={'Full'}
                      />
              </Segment>
          </Container>
  </>

  );
};

interface SubscriptionProps {
  title: string;
  description: string;
  accessKind?: 'Full' | 'Restricted';
  restrictedAccess?:boolean;
  url?: string;
}

const Subscription: FC<SubscriptionProps> = ({ title, description, accessKind, url }) => {

  const history = useHistory();
  const handleClick = () => {
    history.push(url!)
  };

  return (
    <Segment style={{ boxShadow: 'none', border: 'none' }}>
      <Grid columns={2} verticalAlign='middle'>
        <Grid.Row>
          <Grid.Column width={10}>
            <Header as='h3' style={{fontSize: 18}}>
              {accessKind === 'Full' && <Icon name='check circle outline' color='green' size='small' />}
              {title}

            </Header>
            <p>{description}</p>
          </Grid.Column>
          <Grid.Column width={6} textAlign='right'>
            <Button primary style={{ marginRight: '30px' }}
              onClick={handleClick}
            >See It in Action</Button>
            {/*<Button secondary={active} disabled={!active}>Upgrade</Button>*/}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
  );
};

export default Dashboard;